<script>
import moment from 'moment';
import selectStaff from "@/view/user/common/selectStaff.vue";

export default {
  name: "venueInfo",
  computed: {
    selectStaff() {
      return selectStaff
    }
  },
  data() {
    return {
      activeKey: 0,
      info: {
        name: '空间名称',
        remark: '空间描述空间描述空间描述空间描述空间描述空间描述空间描述空间描述空间描述',
      },
      showTime: true,
      current: 0,
      fakeDate: '1996-01-06 ',
      currentDateOption: [],
      images: [
        'https://img01.yzcdn.cn/vant/apple-1.jpg',
        'https://img01.yzcdn.cn/vant/apple-2.jpg',
      ],
      timeSelectList: [],
      timeIndexList: []
    };
  },
  created() {
    this.timeSelectList = [
      { time: '今天', id: 1, start: '06:00', end: '22:00', occupied: [{ start: '06:00', end: '08:00' }, { start: '21:00', end: '24:00' }] },
      { time: '明天', id: 2 },
      { time: '后天', id: 3 },
      { time: '2024-06-08', id: 4 },
      { time: '2024-06-09', id: 5 },
      { time: '2024-06-10', id: 6 },
      { time: '2024-06-11', id: 7 }
    ]
    // 示例使用
    const currentOption = this.timeSelectList[0]
    const date = this.fakeDate // 随便搞个日期 使用moment
    const start = '06:00'
    const end = '24:00'
    if (end === '24:00') {
      let startHour = date + start; // 开始小时
      let endHour = date + '23:00'; // 结束小时
      let hours = this.splitHoursRange(startHour, endHour);
      hours.push('24:00')
      let result = [];
      for (let i = 0; i < hours.length - 1; i++) {
        result.push({
          start: hours[i],
          end: hours[i + 1]
        });
      }
      result.forEach(item => {
        item.occupied = false
        // 判断是否被占用或
        currentOption.occupied.forEach(son => {
          if (!item.occupied) {
            let startTimeA = moment(date + son.start);
            let endTimeA = moment(date + son.end);
            let startTimeB = moment(date + item.start);
            let endTimeB = moment(date + item.end);
            let isBWithinA = this.isWithinRange(startTimeA, endTimeA, startTimeB, endTimeB);
            item.occupied = isBWithinA
          }
        })
      })
      this.currentDateOption = result
    } else {
      let startHour = date + start; // 开始小时
      let endHour = date + end; // 结束小时
      let hours = this.splitHoursRange(startHour, endHour);
      let result = [];
      for (let i = 0; i < hours.length - 1; i++) {
        result.push({
          start: hours[i],
          end: hours[i + 1]
        });
      }
      result.forEach(item => {
        item.occupied = false
        // 判断是否被占用或
        currentOption.occupied.forEach(son => {
          if (!item.occupied) {
            let startTimeA = moment(date + son.start);
            let endTimeA = moment(date + son.end);
            let startTimeB = moment(date + item.start);
            let endTimeB = moment(date + item.end);
            let isBWithinA = this.isWithinRange(startTimeA, endTimeA, startTimeB, endTimeB);
            item.occupied = isBWithinA
          }
        })
      })
      this.currentDateOption = result
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    onChange(index) {
      this.current = index;
    },
    splitHoursRange(start, end) {
      // 创建一个基准日期（这里使用当前日期，但你可以根据需要设置任何日期）
      let baseDate = moment();
      // 重置分钟和秒为0（可选，但有助于保持一致性）
      baseDate.minute(0).second(0);
      // 创建一个数组来存储每个小时的时间点
      let hours = [];
      const startHour = moment(start).hour()
      const endHour = moment(end).hour()
      // 循环从startHour到endHour（包括endHour）
      for (let i = startHour; i <= endHour; i++) {
        // 设置当前小时，并克隆以避免修改基准日期
        let currentHour = baseDate.clone().hour(i);
        // 将当前小时添加到数组中（这里以字符串形式返回）
        hours.push(currentHour.format('HH:00')); // 或者使用你想要的任何格式
      }
      return hours;
    },
    // 判断时间段A是否包含时间段B
    isWithinRange(startA, endA, startB, endB) {
      return startB.isSameOrAfter(startA) && endB.isSameOrBefore(endA);
    },
    selectTime(index, occupied) {
      if (!occupied) {
        if (this.timeIndexList.includes(index)) {
          this.timeIndexList = this.timeIndexList.filter(item => {
            return item !== index;
          })
        } else {
          this.timeIndexList.push(index);
        }
      }
    }
  }
}
</script>

<template>
  <div class="venue-info">
    <van-nav-bar title="空间详情" left-arrow @click-left="back" />
    <van-swipe class="my-swipe" @change="onChange">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img v-lazy="image" />
      </van-swipe-item>
      <template #indicator>
        <div class="custom-indicator">{{ current + 1 }}/{{ images.length }}</div>
      </template>
    </van-swipe>
    <div class="venue-info-content">
      <div class="venue-info-name">{{ info.name }}</div>
      <div class="venue-info-remark">{{ info.remark }}</div>
    </div>
    <van-cell-group>
      <van-cell title="预约时间" is-link value="请选择">
      </van-cell>
      <div class="venue-info-label">
        2024-5-30 09:00~12:00；19:00~20:00；19:00~20:00；19:00~20:00；
      </div>
    </van-cell-group>
    <div class="venue-info-tips-title">取消预约规则</div>
    <div class="venue-info-tips">如遇突发情况无法，可在预约时间的前20分钟前免费取消，逾期不可取消/变更。</div>
    <div class="venue-info-btn">
      <div class="venue-info-hour">共3小时</div>
      <div class="venue-info-confirm">确认预约</div>
    </div>
    <van-popup v-model="showTime" position="bottom" :style="{ height: '80%' }">
      <div class="venue-info-popup-nav">
        <div class="venue-info-popup-cancel">取消</div>
        <div class="venue-info-popup-title">请选择预约时间</div>
        <div class="venue-info-popup-confirm">确定</div>
      </div>
      <div class="venue-info-popup-time">
        <van-sidebar v-model="activeKey">
          <van-sidebar-item v-for="item in timeSelectList" :title="item.time" :key="item.id" />
        </van-sidebar>
        <div class="venue-info-time">
          <div v-for="(item, index) in currentDateOption" :key="index" class="venue-info-time-item" @click="() => selectTime(index, item.occupied)">
            <div :class="item.occupied ? 'venue-info-time-occupied' : (timeIndexList.includes(index) ? 'venue-info-time-index' : 'venue-info-time-value')">
              <div class="venue-info-time-title">
                {{item.start }}~{{item.end}}
              </div>
              <div class="venue-info-time-status">
                {{ item.occupied ? '已预约' : (timeIndexList.includes(index) ? '已选中' : '可预约') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<style scoped lang="less">
.change_val(@name, @px){
    @{name}: @px / 200.6 * 1rem;
}
.change_margin(@name, @top, @right){
    @{name}: @top / 200.6 * 1rem @right / 200.6 * 1rem;
}
.venue-info {
  height: 100vh;
  position: relative;
  .change_val(margin-bottom, 74);
  .my-swipe {
    .van-swipe-item {
      width: 100%;
      .change_val(height, 474);
      img {
        width: 100%;
        .change_val(height, 474);
      }
    }
    .custom-indicator {
      position: absolute;
      right: 5px;
      bottom: 5px;
      padding: 2px 5px;
      font-size: 12px;
      background: rgba(0, 0, 0, 0.1);
    }
  }
  .venue-info-content {
    background: #FFFFFF;
    .change_margin(padding, 32, 32);
    .change_val(margin-bottom, 24);

    .venue-info-name {
      font-weight: 500;
      color: #333333;
      .change_val(font-size, 32);
    }

    .venue-info-remark {
      font-weight: 400;
      color: #999999;
      .change_val(margin-top, 20);
      .change_val(font-size, 24);
    }
  }
  .venue-info-tips-title {
    color: #999999;
    font-weight: 500;
    .change_val(font-size, 30);
    .change_val(margin-top, 20);
    .change_val(margin-left, 20);
    .change_val(margin-right, 20);
  }
  .venue-info-tips {
    color: #999999;
    .change_val(margin-left, 20);
    .change_val(margin-right, 20);
    .change_val(font-size, 30);
  }
  .venue-info-btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(159,203,222,0.5);
    .change_val(height, 120);

    .venue-info-hour {
      font-weight: 400;
      color: #999999;
      .change_val(font-size, 24);
      .change_val(padding-left, 32);
    }

    .venue-info-confirm {
      background: linear-gradient( 347deg, #00C9FF 0%, #1677FF 100%);
      font-weight: 500;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      .change_val(width, 200);
      .change_val(height, 74);
      .change_val(border-radius, 40);
      .change_val(font-size, 30);
    }
  }
  .venue-info-label {
    color: #1677FF;
    font-weight: 400;
    .change_val(font-size, 28);
    .change_val(padding-left, 32);
    .change_val(padding-bottom, 32);
  }
  .venue-info-popup-nav {
    display: flex;
    justify-content: space-between;
    .change_val(padding-top, 20);
    .change_val(padding-left, 30);
    .change_val(padding-right, 30);

    .venue-info-popup-cancel {
      color: #1677FF;
      font-weight: 500;
      .change_val(font-size, 30);

    }

    .venue-info-popup-title {
      color: #333333;
      font-weight: 500;
      .change_val(font-size, 36);
    }

    .venue-info-popup-confirm {
      color: #1677FF;
      font-weight: 500;
      .change_val(font-size, 30);
    }
  }
  /deep/.van-sidebar {
    width: 120px;
  }

  .venue-info-popup-time {
    display: flex;
    border: 1px solid red;
    .venue-info-time {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      .venue-info-time-item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 49%;
        .venue-info-time-value {
          .change_margin(margin, 8, 8);
          .change_margin(padding, 16, 8);
          .change_val(border-radius, 8);
          background-color: #f5f5f5;
          text-align: center;
          width: 100%;
          .venue-info-time-title {
            .change_val(font-size, 30);
            color: #333333;
          }
          .venue-info-time-status {
            .change_val(font-size, 26);
            color: #1677ff;
          }
        }

        .venue-info-time-occupied {
          .change_margin(margin, 8, 8);
          .change_margin(padding, 16, 8);
          .change_val(border-radius, 8);
          background-color: #cccccc;
          text-align: center;
          width: 100%;
          .venue-info-time-title {
            .change_val(font-size, 30);
            color: #333333;
          }
          .venue-info-time-status {
            .change_val(font-size, 26);
            color: #999999;
          }
        }

        .venue-info-time-index {
          .change_margin(margin, 8, 8);
          .change_margin(padding, 16, 8);
          .change_val(border-radius, 8);
          background-color: #e7f1ff;
          text-align: center;
          width: 100%;
          .venue-info-time-title {
            .change_val(font-size, 30);
            color: #1677ff;
          }
          .venue-info-time-status {
            .change_val(font-size, 26);
            color: #999999;
          }
        }
      }
    }
  }
}
</style>
